import FooterSocialsPresenter from "../components/footer-socials/presenter/footer-socials.js";

const footerSocialsElement = document.querySelector(`.footer .socials`);
const priceListButton = document.querySelector(`.footer .button_download-pricelist`);

if (footerSocialsElement && priceListButton) {
  const footerSocialsComponent = new FooterSocialsPresenter(footerSocialsElement, priceListButton);
  footerSocialsComponent.init();
}
